import { render, staticRenderFns } from "./ScaniaIndicatorSymbols.vue?vue&type=template&id=834948ae&"
import script from "./ScaniaIndicatorSymbols.vue?vue&type=script&lang=js&"
export * from "./ScaniaIndicatorSymbols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports